const { isNavigationFailure, NavigationFailureType } = require('vue-router');

/**
 * Where the global guard sends a visit to a route with this `meta`, or null to let it through.
 * Logged-in non-admins go Home: /login_redirect would only ask them to log in again.
 */
const authRedirect = (meta, { loggedIn, admin }) => {
  if (!meta.requiresAuth) return null;
  if (!loggedIn) return '/login_redirect';
  if (meta.adminOnly && !admin) return '/';
  return null;
};

/** A guard redirect, or a push to the page already shown: router.push rejects, but nothing went wrong. */
const isRedirect = (err) =>
  Boolean(
    isNavigationFailure(err, NavigationFailureType.redirected) ||
      isNavigationFailure(err, NavigationFailureType.duplicated),
  );

/** For router.push(...).catch(ignoreRedirect): swallow redirects, rethrow real errors. */
const ignoreRedirect = (err) => {
  if (!isRedirect(err)) throw err;
};

module.exports = { authRedirect, ignoreRedirect, isRedirect };
